import React from 'react';
import { STATE_META, type CmsState } from '../../utils/cmsState';

/** SAM-1095: Draft (amber) / Scheduled (blue) / Published (green) / Expired (grey); the last two are worked out from the dates. */
export const CmsStateBadge: React.FC<{ state: CmsState }> = ({ state }) => {
  const m = STATE_META[state];
  return (
    <span
      className="inline-block text-[12px] font-semibold whitespace-nowrap"
      style={{ padding: '3px 10px', borderRadius: 12, background: m.bg, color: m.fg }}
    >
      {m.label}
    </span>
  );
};
